/**
 * Writes /sounds filter state (q, sort, category, model, picks, page) into the
 * address bar without a navigation.
 *
 * `/sounds` is a static page and loads its list on the client, so no server
 * render depends on these params. `router.push` still fetched the page's RSC
 * payload on every change, and on production that cached, prerendered payload
 * made the router fall back to a full document load, which re-ran the writers
 * and reloaded again in a loop (PR #1198, reverted in #1200). Next.js patches
 * `history.pushState` to update `useSearchParams` in place (ACTION_RESTORE in
 * next/dist/client/components/app-router.js), so this keeps the URL and the
 * hooks in sync with no server request at all.
 *
 * Writing the URL the address bar already shows is a no-op, so a writer that
 * re-asserts unchanged state cannot add history entries.
 */
export function writeSoundsUrl(url: string): void {
  if (typeof window === 'undefined') return
  if (window.location.pathname + window.location.search === url) return
  window.history.pushState(null, '', url)
}
